import { ImmutableAppointmentStatus, MutableAppointmentStatus } from './types'

const mutableAppointmentStatus: Record<MutableAppointmentStatus, true> = {
  CONFIRMED: true,
  DENIED: true,
  PENDING: true,
} as const

const mutableAppointmentStatuses = new Set<MutableAppointmentStatus>(Object.keys(mutableAppointmentStatus) as MutableAppointmentStatus[])

const statusToNoActionTitle: Record<ImmutableAppointmentStatus, string> = {
  CANCELED: 'pages.appointment.cancel.alreadyCanceled',
  COMPLETED: 'pages.appointment.alreadyCompleted',
  RESCHEDULED: 'pages.appointment.reschedule.alreadyRescheduled',
} as const

export { mutableAppointmentStatuses, statusToNoActionTitle }
